import AuditLog from "../js/components/auditLog/AuditLog.react";
export default AuditLog;
